module.exports = __webpack_public_path__ + "cbee7770f7428b1c95830a3b13d1800a.png";